"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.patch = exports.put = exports.post = exports.get = void 0;
const config_1 = __importDefault(require("./config"));
async function get(url, params = {}, headers, signal) {
    return (await config_1.default.get(url, { params, headers, signal })).data;
}
exports.get = get;
async function post(url, body, headers) {
    return (await config_1.default.post(url, body, { headers })).data;
}
exports.post = post;
async function put(url, body, headers) {
    return (await config_1.default.put(url, body, { headers })).data;
}
exports.put = put;
async function patch(url, body, headers) {
    return (await config_1.default.patch(url, body, { headers })).data;
}
exports.patch = patch;
async function remove(url, params = {}, headers) {
    return (await config_1.default.delete(url, { params, headers })).data;
}
exports.remove = remove;
